<template>
  <div>
    <h2 class="page-title">号段信息</h2>

    <el-alert
      v-if="!profile.allowCreateSegments"
      title="当前供应商未开通“可创建号段”特殊权限，暂不能创建新号段。"
      type="warning"
      :closable="false"
      show-icon
      style="margin-bottom:20px;"
    />

    <div v-if="profile.allowCreateSegments" class="card-panel">
      <h3 class="section-title">新建号段</h3>
      <p class="section-desc">创建当前供应商可使用的 SN段1，并配置产品名、计划投放日期和地区。</p>
      <el-form :model="createForm" label-position="top" class="form-grid">
        <el-form-item label="SN段1">
          <el-input v-model="createForm.segmentCode" maxlength="4" placeholder="4位数字" @input="createForm.segmentCode = (createForm.segmentCode || '').replace(/\D/g, '').slice(0, 4)" />
        </el-form-item>
        <el-form-item label="产品名">
          <el-input v-model="createForm.productName" />
        </el-form-item>
        <el-form-item label="计划投放日期">
          <el-date-picker
            v-model="createForm.launchDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"
            style="width:100%;"
          />
        </el-form-item>
        <el-form-item label="计划投放地区">
          <el-input v-model="createForm.launchRegion" placeholder="可选" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="createForm.status" style="width:100%;">
            <el-option label="active" value="active" />
            <el-option label="inactive" value="inactive" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="action-row">
        <el-button type="primary" :disabled="!profile.allowCreateSegments" @click="handleCreate">创建号段</el-button>
      </div>
    </div>

    <div class="card-panel">
      <h3 class="section-title">维护已有号段</h3>
      <p class="section-desc">维护已分配号段的产品信息、投放计划和启用状态。</p>
      <template v-if="segments.length">
        <el-form :model="segmentForm" label-position="top" class="form-grid">
          <el-form-item label="选择号段">
            <el-select v-model="segmentForm.id" placeholder="请选择号段" style="width:100%;" @change="applySegment">
              <el-option
                v-for="segment in segments"
                :key="segment.id"
                :label="`SN段1 ${segment.segmentCode} / ${segment.productName || '未设置产品名'}`"
                :value="segment.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="产品名">
            <el-input v-model="segmentForm.productName" />
          </el-form-item>
          <el-form-item label="计划投放日期">
            <el-date-picker
              v-model="segmentForm.launchDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"
              style="width:100%;"
            />
          </el-form-item>
          <el-form-item label="计划投放地区">
            <el-input v-model="segmentForm.launchRegion" placeholder="可选" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="segmentForm.status" style="width:100%;">
              <el-option label="active" value="active" />
              <el-option label="inactive" value="inactive" />
            </el-select>
          </el-form-item>
        </el-form>
        <div class="action-row">
          <el-button type="primary" :disabled="!segmentForm.id" @click="saveSegment">保存号段信息</el-button>
        </div>
      </template>
      <div v-else class="empty-panel">暂无号段</div>
    </div>
  </div>
</template>

<script>
import { createVendorSegment, getVendorProfile, getVendorSegments, updateVendorSegment } from '../../api/vendor'

const defaultCreateForm = () => ({
  segmentCode: '',
  productName: '',
  launchDate: '',
  launchRegion: '',
  status: 'active',
})

const defaultSegmentForm = () => ({
  id: '',
  productName: '',
  launchDate: '',
  launchRegion: '',
  status: 'active',
})

export default {
  data() {
    return {
      profile: {
        allowCreateSegments: false,
      },
      createForm: defaultCreateForm(),
      segments: [],
      segmentForm: defaultSegmentForm(),
    }
  },
  created() {
    this.loadProfile()
    this.loadSegments()
  },
  methods: {
    async loadProfile() {
      const { data } = await getVendorProfile()
      this.profile = data
    },
    async loadSegments(preferredId = '') {
      const { data } = await getVendorSegments()
      this.segments = data
      const targetId = preferredId || this.segmentForm.id || (data[0] && data[0].id)
      if (targetId) {
        this.applySegment(targetId)
      } else {
        this.segmentForm = defaultSegmentForm()
      }
    },
    applySegment(id) {
      const current = this.segments.find(item => item.id === id)
      if (!current) return
      this.segmentForm = {
        id: current.id,
        productName: current.productName || '',
        launchDate: current.launchDate || '',
        launchRegion: current.launchRegion || '',
        status: current.status || 'active',
      }
    },
    async handleCreate() {
      if (!this.profile.allowCreateSegments) {
        this.$message.error('当前供应商未开通“可创建号段”特殊权限')
        return
      }
      try {
        const { data } = await createVendorSegment(this.createForm)
        this.$message.success('号段创建成功')
        this.createForm = defaultCreateForm()
        await this.loadSegments(data?.id)
      } catch (error) {
        this.$message.error(error.response?.data?.message || '创建失败')
      }
    },
    async saveSegment() {
      try {
        await updateVendorSegment(this.segmentForm.id, this.segmentForm)
        this.$message.success('号段信息已保存')
        await this.loadSegments(this.segmentForm.id)
      } catch (error) {
        this.$message.error(error.response?.data?.message || '保存失败')
      }
    },
  },
}
</script>
